import React, { useEffect, useState } from 'react'
import ExpenseRegisterModel from './models/ExpenseRegisterModel'

function ViewExpenseRegister({ ExpenseRegisterData }) {
  const [expenseRegisterData, setExpenseRegisterData] = useState(new ExpenseRegisterModel())

  useEffect(() => {
    setExpenseRegisterData(ExpenseRegisterData)
  }, [ExpenseRegisterData])

  return (
    <>
      <div className="row">
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Expense Category</label>
          <input type="text" className="form-control" value={expenseRegisterData.ExpenseCategoryName ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Expense Date</label>
          <input type="text" className="form-control" value={expenseRegisterData.ExpenseDate ? expenseRegisterData.ExpenseDate.split('T')[0] : ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Amount</label>
          <input type="text" className="form-control" value={expenseRegisterData.Amount ?? ''} disabled />
        </div>
        <div className="col-lg-6 mb-3 add-product">
          <label className="form-label">Reference</label>
          <input type="text" className="form-control" value={expenseRegisterData.ReferenceNo ?? ''} disabled />
        </div>
        <div className="col-lg-12 mb-3 add-product">
          <label className="form-label">Expense For</label>
          <input type="text" className="form-control" value={expenseRegisterData.ExpenseFor ?? ''} disabled />
        </div>
        <div className="col-lg-12 mb-3 add-product">
          <label className="form-label">Description</label>
          <textarea className="form-control" rows={4} value={expenseRegisterData.Description ?? ''} disabled />
        </div>
      </div>
    </>
  )
}

export default ViewExpenseRegister
